<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import AddEditForm from '@/components/popup-items/AddEditForm';
import SingleView from '@/components/elements/views/SingleView';

export default {
    page: {
        title: 'Manage Popup Item'
    },

    components: {
        AddEditForm
    },

    extends: SingleView,

    validations: {
        item: {
            title: {
                required
            },
            description: {
                required
            },
            articleId: {
                required
            },
            date: {
                required
            },
            endTime: {
                notBeforeStartDate(v) {
                    return this.item.startTime
                        ? this.$dayjs(v).isAfter(this.item.startTime)
                        : true;
                }
            }
        }
    },

    data() {
        const { key } = this.$route.params;

        return {
            backRoute: `/contents/${key}/popup-items`,
            indexName: 'Popup',
            singleItemName: 'popup item',
            key,
            item: {
                isHidden: false
            }
        };
    },

    computed: {
        sections() {
            const sections = {
                permalink: false,
                meta: false
            };

            if (this.editMode) {
                sections.status = true;
            }

            return sections;
        },

        breadcrumbs() {
            const { id = null } = this.$route.params;

            return [
                {
                    text: 'Cancer',
                    to: '/'
                },
                {
                    text: 'Pages',
                    to: '/contents'
                },
                {
                    text: 'Popup',
                    to: `/contents/${this.key}`
                },
                {
                    text: 'Popup Items',
                    to: `/contents/${this.key}/popup-items`
                },
                {
                    text: id ? 'Edit' : 'Add',
                    active: true
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItem: 'popupItems/show',
            addItem: 'popupItems/store',
            updateItem: 'popupItems/update',
            deleteItem: 'popupItems/destroy'
        })
    }
};
</script>
